import type { UUID } from './index';

export enum AccountStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled'
}

export enum AuthMethod {
  EMAIL = 'email',
  OAUTH = 'oauth'
}

export interface User {
  id: UUID;
  name: string;
  // EMAIL REMOVED: Email is now exclusively stored in GoTrue (auth.users.email)
  // Use GoTrue API to fetch email data when needed
  authUserId: string | null;
  member_type: number | null;
  bio: string | null;
  avatar: string | null;
  alias: string | null;
  sessionId?: string | null;
  accountStatus?: AccountStatus;
  disabledAt?: Date | null;
  disabledReason?: string | null;
};

export interface MemberProfile {
  id: User['id'];
  name: User['name'];
  // EMAIL REMOVED: Email is now exclusively stored in GoTrue (auth.users.email)  
  // Email should be fetched from GoTrue when needed for profile display
  email?: string; // Optional email fetched from GoTrue for UI display
  avatar: User['avatar'];
  alias: User['alias'];
  bio: User['bio'];
}

export enum UserType {
  GUEST = 'guest',
  MEMBER = 'member'
}
